<template>
  <path pid="0" d="M20.78 5.22A11 11 0 0013 2a1 1 0 00-1 1v10a1 1 0 001 1h10a1 1 0 001-1 11 11 0 00-3.22-7.78zM14 12V4.06A9 9 0 0121.94 12z"/><path pid="1" d="M9.4 4.75a1 1 0 10-.8-1.83 11 11 0 1014.53 14.36 1 1 0 10-1.84-.78A9 9 0 119.4 4.75z"/>
</template>
